import * as React from "react";

import { useAboutContent } from "../providers";

export const About: React.FunctionComponent = (props) => {
  const { content: aboutContent } = useAboutContent();

  const [isOpen, setIsOpen] = React.useState(false);

  const onTitleContainerClick = () => {
    setIsOpen(!isOpen);
  };

  const onMountContent: React.LegacyRef<HTMLDivElement> = (element) => {
    (window.require as any)(["jquery"], function ($: any) {
      if (element) {
        const $element = $(element);
        if ($element && $element.length > 0) {
          $element.html(aboutContent || "");
          $element.trigger("contentUpdated");
        }
      }
    });
  };

  return (
    <div
      className={`purchase-page-about-container ${isOpen ? "open" : "closed"}`}
    >
      <div className="title-container" onClick={onTitleContainerClick}>
        <h4>About our e-gift cards</h4>
      </div>
      <div className="content-container">
        <div className="content" ref={onMountContent}></div>
      </div>
    </div>
  );
};
